import { useTranslation } from 'react-i18next'

const OnHoldMessage = () => {
  const { t } = useTranslation()

  return (
    <p>
      <strong>
        {t('Antes de continuar con el proceso, tu solicitud tendrá que ser revisada y aprobada manualmente.')}
      </strong>
    </p>
  )
}

export default OnHoldMessage
